import { Injectable, signal } from '@angular/core'

export interface AvatarPickerConfig {
  currentAvatar: string
  onSelected: (url: string) => void
  onFileSelected: (file: File, previewUrl: string) => void
}

@Injectable({ providedIn: 'root' })
export class AvatarPickerService {
  readonly config = signal<AvatarPickerConfig | null>(null)

  open(config: AvatarPickerConfig): void {
    this.config.set(config)
  }

  close(): void {
    this.config.set(null)
  }
}
